import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

export const CartCheckoutBreadCrumb = ({ step }) => {
  const getStep = (step) => {
    switch (step) {
      case 1:
        return [
          {
            name: "Home",
            link: "/",
          },
          {
            name: "Shopping Cart",
            link: "/cart-checkout",
          },
        ];

      case 2:
        return [
          {
            name: "Home",
            link: "/",
          },
          {
            name: "Shopping Cart",
            link: "/cart-checkout",
          },
          {
            name: "Shipping Address",
            link: "/cart-checkout",
          },
        ];
      case 3:
        return [
          {
            name: "Home",
            link: "/",
          },
          {
            name: "My Cart",
            link: "/cart-checkout",
          },
          {
            name: "Shipping Address",
            link: "/cart-checkout",
          },
          {
            name: "Payment Method",
            link: "/cart-checkout",
          },
        ];
      default:
        return [
          {
            name: "Home",
            link: "/",
          },
          {
            name: "My Cart",
            link: "/cart-checkout",
          },
          {
            name: "Shipping Address",
            link: "/cart-checkout",
          },
          {
            name: "Payment Method",
            link: "/cart-checkout",
          },
          {
            name: "Review & Confirm",
            link: "/cart-checkout",
          },
        ];
    }
  };

  return <BreadCrumb list={getStep(step)} />;
};
